import React, { Component, Fragment } from "react";
import { translate } from "../Services/translation";
import ReactPlayer from "react-player";

class VideoPlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            playing: false,
            videoUrl: "",
        };
    }
    componentDidMount() {
        if (this.props.isLoggedIn) {
            this.setState({
                videoUrl: this.props.userHasAccess ? this.props.full : this.props.preview,
            });
        } else {
            this.setState({
                videoUrl: this.props.preview,
            });
        }
    }

    togglePlayingState() {
        this.setState((previousState) => ({
            playing: !previousState.playing,
        }));
    }

    render() {
        const { playing, videoUrl } = this.state;

        return (
            <Fragment>
                {videoUrl && (
                    <div
                        className={`video-player__container ${
                            this.props.isLoggedIn ? "green" : "red"
                        }`}
                    >
                        <div
                            className={`video-player__player ${
                                playing ? "video-player__player--playing" : ""
                            }`}
                        >
                            <ReactPlayer
                                className={`react-player`}
                                width="100%"
                                height="100%"
                                playing={playing}
                                controls={true}
                                loop={false}
                                playsinline={false}
                                url={`https://vimeo.com/${videoUrl}`}
                            />
                        </div>
                        <div className={`video-player__button-container`}>
                            <button
                                className={`video-player__button ${
                                    playing
                                        ? "video-player__button--playing"
                                        : ""
                                }`}
                                onClick={() => this.togglePlayingState()}
                            >
                                <svg className="video-player__icon">
                                    {playing ? (
                                        <use href="/ui/images/hc/hc-sprite.svg#close"></use>
                                    ) : (
                                        <use href="/ui/images/hc/hc-sprite.svg#play"></use>
                                    )}
                                </svg>
                            </button>
                            <div className="video-player__button-text">
                                {translate(
                                    "productdetail.videoimageboxseevideo"
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </Fragment>
        );
    }
}

export default VideoPlayer;
